import { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';

import { useToggle } from '@hooks';
import { useTranslate } from '@i18n';
import { useCoach } from '@queries';
import { Button, Checkbox } from '@ui';

import { Input } from '../Input';
import { PasswordModal } from '../PasswordModal/PasswordModal';
import { UnselectCoachModal } from '../UnselectCoachModal/UnselectCoachModal';

import * as css from './AccountSection.css';

export const AccountSection = () => {
    const [coachConfirmationModalOpen, setCoachConfirmationModal] = useToggle();
    const { register, setValue, watch } = useFormContext();
    const { data: coachData } = useCoach();
    const isCoach = !!coachData;
    const isCoachSelected = watch('isCoach');

    const [passwordModalOpen, setPasswordModalOpen] = useToggle(false);
    const t = useTranslate();

    useEffect(() => {
        setValue('isCoach', isCoach);
    }, [isCoach, setValue]);

    const handleCoachChange = () => {
        if (isCoachSelected) {
            setCoachConfirmationModal(true);
            return;
        }
        setValue('isCoach', true);
    };

    const onDeselectCoach = () => {
        setValue('isCoach', false);
        setCoachConfirmationModal(false);
    };
    return (
        <>
            <div className={css.accountSettings}>
                <Input label={t('user_settings.name_label')} {...register('name')} />
                <Input type="email" label={t('user_settings.email_label')} {...register('email')} />
                <div className={css.checkbox}>
                    <Checkbox
                        checked={isCoachSelected}
                        onChange={handleCoachChange}
                        label={t('user_settings.coach_toggle')}
                    />
                </div>
                <Button variant="secondary" rounded onClick={() => setPasswordModalOpen(true)}>
                    {t('user_settings.change_password')}
                </Button>
            </div>
            {coachConfirmationModalOpen && (
                <UnselectCoachModal
                    isOpen
                    onConfirm={onDeselectCoach}
                    onDismiss={() => setCoachConfirmationModal(false)}
                />
            )}

            {passwordModalOpen && <PasswordModal modalOpen={passwordModalOpen} setModalOpen={setPasswordModalOpen} />}
        </>
    );
};
